/**
 * Free Shipping Promos - Dynamic Price Display
 * Updates free shipping prices based on user's location
 */

(function () {
    "use strict";

    // Shipping price mapping
    const shippingPrices = {
        AE: "285د.إ",
        AL: "7.700Lek",
        AM: "30.000֏",
        AO: "58.300 Kz",
        AU: "95$",
        BA: "125KM",
        BG: "120лв",
        BR: "500 R$",
        CA: "85$",
        CH: "60CHF",
        LI: "60CHF",
        CM: "42300 CFA",
        CZ: "1.500Kč",
        DK: "450kr.",
        DO: "4.200RD$",
        DZ: "9,660 دج",
        EG: "1,900 ج.م",
        ES: "55€",
        GB: "£55",
        GE: "200 GEL",
        HK: "500$",
        HU: "25.000Ft",
        ID: "950.000Rp",
        IL: "210₪",
        IN: "5,000 ₹",
        JP: "¥9,500",
        KG: "70$",
        TG: "70$",
        GM: "70$",
        KR: "90.000₩",
        KZ: "30.000лв",
        MA: "700 MAD",
        ME: "65€",
        XK: "65€",
        KW: "65€",
        VN: "65€",
        TH: "65€",
        NG: "65€",
        OM: "65€",
        AZ: "65€",
        BH: "65€",
        CV: "65€",
        MD: "65€",
        MK: "4.000ден",
        MX: "800 MXN",
        MY: "335 MYR",
        NO: "800kr",
        NZ: "105$",
        PE: "250S/.",
        PH: "4.400₱",
        PL: "280zł",
        QA: "290ر.ق",
        RO: "290lei",
        RS: "7.600Дин.",
        SA: "265ر.س",
        SE: "650kr",
        SG: "90$",
        TW: "1.800NT$",
        US: "$55",
        UZ: "710.000лв",
        ZA: "1.400R",
    };

    function updateFreeShippingPrices() {
        // Get user's country code from Shopify's localization object
        const userCountryCode =
            window.Shopify && window.Shopify.country
                ? window.Shopify.country
                : null;

        // If no user country or using default setting, don't update
        if (!userCountryCode) {
            return;
        }

        // Find the free shipping promo
        const freeShippingPromo = document.querySelector(
            ".free-shipping-promo"
        );

        if (freeShippingPromo) {
            const priceElement =
                freeShippingPromo.querySelector(
                    ".free-shipping-price"
                );

            if (priceElement) {
                // Check if we have a price for the user's country
                const userCountryPrice =
                    shippingPrices[
                        userCountryCode.toUpperCase()
                    ];

                if (userCountryPrice) {
                    priceElement.textContent =
                        userCountryPrice;
                } else {
                    // Fallback to default ES price if country not found
                    priceElement.textContent = "55€";
                }
            }
        }
    }

    // Initialize on DOM ready
    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            updateFreeShippingPrices
        );
    } else {
        updateFreeShippingPrices();
    }

    // Also update when Shopify country changes (for markets/internationalization)
    document.addEventListener(
        "shopify:section:load",
        function () {
            updateFreeShippingPrices();
        }
    );
})();
